export default "<div class=\"text-button-wrapper\" [ngClass]=\"{'isActive':this.isActive}\">\r\n  {{this.text}}\r\n</div>\r\n"